var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tel-orange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.687,
    height: 17.685,
    viewBox: "0 0 17.687 17.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M3.208,1.692a1.929,1.929,0,0,1,2.886.179L8.076,4.42A1.924,1.924,0,0,1,8.425,6.07l-.6,2.42a.75.75,0,0,0,.2.712l2.716,2.715a.75.75,0,0,0,.712.2l2.419-.6a1.929,1.929,0,0,1,1.652.349l2.549,1.982a1.928,1.928,0,0,1,.18,2.886L17.1,17.871a3.072,3.072,0,0,1-3.18.776,20.6,20.6,0,0,1-7.747-4.886A20.6,20.6,0,0,1,1.289,6.014a3.073,3.073,0,0,1,.776-3.181L3.208,1.691Z",
    transform: "translate(-1.124 -1.127)",
    fill: "#f39628",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelOrange);
export default __webpack_public_path__ + "static/media/icon-tel-orange.ac498a712623dd157a66730410492c7c.svg";
export { ForwardRef as ReactComponent };